<template>
  <GenericDialog
    v-model="internalModel"
    :title="title"
    :data-cy="dataCy"
    :max-width="maxWidth"
    :persistent="persistent"
    :show-close-button="showCloseButton"
    :show-divider="showDivider"
    :loading="loading"
    @cancel="$emit('cancel')"
    @close="handleClose"
  >
    <slot />

    <template #actions>
      <v-card-actions v-if="showActions">
        <v-spacer />
        <v-btn
          v-if="showSubmitButton"
          color="primary"
          :loading="loading"
          :disabled="loading || submitDisabled"
          data-cy="form-submit-button"
          @click="$emit('submit')"
        >
          {{ submitLabel }}
        </v-btn>
      </v-card-actions>
    </template>
  </GenericDialog>
</template>

<script setup>
import { computed } from 'vue'
import GenericDialog from './GenericDialog.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    required: true
  },
  dataCy: {
    type: String,
    default: null
  },
  maxWidth: {
    type: [String, Number],
    default: 720
  },
  persistent: {
    type: Boolean,
    default: true
  },
  showCloseButton: {
    type: Boolean,
    default: true
  },
  showDivider: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  submitDisabled: {
    type: Boolean,
    default: false
  },
  submitLabel: {
    type: String,
    default: 'Save'
  },
  showSubmitButton: {
    type: Boolean,
    default: true
  },
  showActions: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue', 'submit', 'cancel', 'after-close'])

const internalModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// Handle close event from GenericDialog
// Wait 500ms before emitting after-close to prevent user from seeing validation errors during form reset
const handleClose = () => {
  setTimeout(() => {
    emit('after-close')
  }, 500)
}
</script>
